import axios from 'axios'

import { captureExceptionIfProduction } from 'helpers/utils'

export const generateSearch = (organized_values: any, notify: Function, redirectTo: Function) => {
  axios
    .post(`/api/v1/console/searches/query_loads_async/`, organized_values)
    .then((response) => {
      notify('Searching for loads. Refresh the page in a few seconds to see results.', {
        type: 'info',
      })
      redirectTo(`/searches/${response['data']['query_id']}/show`)
    })
    .catch((error) => {
      notify(`${error.message}. ${error.response?.data}`, { type: 'warning' })
      captureExceptionIfProduction(error)
    })
}
